export default __webpack_public_path__ + "static/media/Herb_Morgan.f50d534c.png";